type SortByType = "ASC" | "DESC";

export interface SortItem {
  text: string;
  order: SortByType;
  columns: string;
}

export const sortOptions: SortItem[] = [
  {
    text: "Alphabetically (A - Z)",
    columns: "name",
    order: "ASC",
  },
  {
    text: "Reverse Alphabetically (Z - A)",
    columns: "name",
    order: "DESC",
  },
  {
    text: "Price (Low - High)",
    columns: "price",
    order: "ASC",
  },
  {
    text: "Price (High - Low)",
    columns: "price",
    order: "DESC",
  },
];
